export type IJurisdiction = {
  description: string;
  observation: string;
  value: string;
};

export type IJurisdictions = {
  id: number;
  slug: string;
  is_active: string;	
  description: string;
  observation: string;
  created_at: string | null;
  updated_at: string | null;
  deleted_at: string | null;
}

export type IGetJurisdictionsCompanyStructures = {
  id: string;
  name: string;
  jurisdiction_id: number;
  deleted_at: string | null;
  created_at: string | null;
  updated_at: string | null;
}

export type ISummary = {
  data: {
    fees: {
      description: string;
      observation: string;
      value: string;
    }[];
    jurisdictions: {
      description: string;
      observation: string;
      value: string;
    }[];
    objectives: {
      description: string;
      value: string;
    }[];
    addons: {
      description: string;
      value: string;
    }[];
    config: {
      description: string;
      value: string;
    }[];
  };
};

export type ServiceBaseConfig = {
  headers: {
    Authorization: string;
    'Content-Language': 'pt-BR' | 'en' | 'es' | string;
    'Content-Type'?: 'application/json' | 'multipart/form-data' | string;
  };
  params?: {
    page: number
  }
};

export type ChooseObjectivesPayload = {
  legal_personality: string;
  objectives: {
    objective_slug: string;
  }[];
};

export type ChooseObjectivesResponse = {
  response: string;
  data: {
    account_plan: string;
    config_plan: string;
  };
};

export type ChooseDirectorsPayload = {
  slug_plan: string;
  number_of_director: number;
  is_corporate_director: boolean;
};

export type ChooseDirectorsResponse = any;

export type ChooseShareholdersPayload = {
  slug_plan: string;
  shareholders: number;
  // underages: number;
};

export type ChooseShareholdersResponse = any;

export type ChooseAddonsPayload = {
  slug_plan: string;
  addons: {
    addon_slug: string;
  }[];
};

export type ChooseAddonsResponse = any;

export type GetJurisdictionPayload = {
  slug_plan: string;
};

export type GetJurisdictionResponse = {
  data: IJurisdiction[];
};

export type GetJurisdictionsResponse = {
  data: IJurisdictions[];
};

// export type GetAllJurisdictionsResponse = {
//   data: IJurisdictions[];
// };

export interface IAllJurisdictions {
  instance_jurisdiction_id: string
  is_active: 1 | 0
  jurisdiction_description: string
  jurisdiction_id: number
  value: number
}

export interface IAllConfigs {
  config_id?: string;
  instance_config_id?: string | null
  corporate_director_value: number
  directors_value: number
  shareholders_value: number
  underages_value?: number
}

export interface GetAllJurisdictionsResponse {
  data: {
    data: IAllJurisdictions[]
  }
}

export interface GetConfigsResponse {
  data: {
    data: IAllConfigs
  }
}

export type GetJurisdictionsCompanyStructuresResponse = {
  success: boolean;
  data: IGetJurisdictionsCompanyStructures[]
}

export type GetSummaryPayload = {
  slug_plan: string;
};

export type UpdateFeePayload = {
  fee_id: number;
  value: number;
  is_active: 0 | 1;
};

export type UpdateAddonsPayload = {
  addon_id: number;
  value: number;
  is_active: boolean | 0 | 1;
};

export type UpdateJurisdictionPayload = {
  jurisdiction_id: number;
  value: number;
  is_active: 0 | 1;
};


export type UpdateColorPayload = {
  type: 'text' | 'button' | 'background' | 'icon' | 'border';
  order: number;
  color: string;
};

export type GetSummaryResponse = ISummary;

export type GetFeesResponse = {
  instance_fee_id: string,
  fee_id: number,
  fee_description: string,
  is_active: 1 | 0,
  value: number,
  jurisdiction_id: number,
  jurisdiction_description: string
}

export type GetAddonsResponse = {
  instance_addon_id: string,
  addon_id: number,
  addon_description: string,
  value: number,
  jurisdiction_id: number,
  addon_type: string,
  is_active: 0 | 1,
}

export type GetFeesResponsePaginated = {
  current_page: number;
  data: GetFeesResponse[];
  total: number;
  per_page: number;
  last_page: number;
};

export type IDocumentInfo = {
  company_id: number;
  shareholder_id: number;
  name: string;
  prove_address_url: string;
  prove_address_aproved: number;
  prove_address_signed: number;
  document_url: string;
  document_aproved: number;
  document_signed: number;
  passport_url: string;
  passport_aproved: number;
  passport_signed: number;
};

export type IDocument = {
  id: number;
  slug: string;
  shareholder_id: number;
  type: string;
  description: string;
  message: null | string;
  prove_address_url: string;
  date_posted: string;
  aproved: number;
  signed: number;
  // Extended fields for document display
  shareholder_name?: string;
  is_director?: number | boolean;
  document_type?: 'address' | 'document' | 'passport';
};

export type ICompanyDocument = {
  length: number;
  id: number;
  type: string;
  company_id: number;
  signed: boolean;
  url: string;
  created_at: string;
  updated_at: string;
  deleted_at: null | string;
  file: {
    file_name: string;
    download_file: string;
  };
};

export type ILanguagePersistence = {
  preferred_language: string;
};

export type GetCompanyDocumentsUserResponse = {
  data: {
    length: number;
    id: number;
    type: string;
    company_id: number;
    signed: boolean;
    url: string;
    created_at: string;
    updated_at: string;
    deleted_at: null | string;
    file: FileDocument;
  };
};

export type GetCompanyDocumentsResponse = {
  data: {
    id: number;
    expire_process: string;
    shareholders: [
      {
        id: number;
        slug: string;
        name: string;
        company_id: number;
        is_director?: number;
        address: IDocument[];
        documents: IDocument[];
        passports: IDocument[];
      }
    ];
  };
};

export interface IAccountPlan {
  account_plan_slug: string;
  configuration_plan_slug: string;
}

export interface IUserContract {
  id: number;
  type: string;
  signed: boolean;
  url: string;
  created_at: Date;
}

export type FileDocument = {
  file_name: string;
  download_file: string;
};

export enum PaymentStatus {
  Created = 'created',
  Pending = 'pending',
  Confirmed = 'confirmed',
  Canceled = 'canceled',
  Failed = 'failed',
  Expired = 'expired'
}

export enum EnumDocumentType {
  Certificate = 'certificate',
  Contract = 'contract'
}
